// extracted by mini-css-extract-plugin
export default {"shiftSeparator":"styles_shiftSeparator__MUIJp"};